export const PERIOD = {
  MONTH: "Mes",
  WEEK: "Semana",
  DAY: "Día",
};

export const REPORT_TYPE = {
  UNIT: "unidad",
  OPERATOR: "operador",
};

export const ORDER_BY = {
  x: "Eje X",
  y: "Eje Y",
};
